<template lang="html">
    <div>
        <div ref="parentSidebar" id="parentx">
            <v-btn v-if="validaFilter" @click="ActivarSide()" color="primary"
                class="btn-flotante transition delay-150 duration-300 ease-in-out transform hover:scale-5 text-white rounded-md"
                style="position:fixed;">
                <v-icon color="white">mdi-filter</v-icon>
            </v-btn>
            <v-btn v-if="validaHelp" color="success" @click="popupActivo = true"
                class="btn-flotante transition delay-150 duration-300 ease-in-out transform hover:scale-5 text-white rounded-md"
                style="position:fixed; top:120px">
                <v-icon color="white">mdi-help</v-icon>
            </v-btn>

            <vs-sidebar position-right default-index="1" color="#34495e" class="sidebarx" spacer click-not-close
                v-model="active">

                <div class="header-sidebar" slot="header">
                    <h4 class=" greyTint--text">
                        Filtros
                        <v-icon color="greyTint">mdi-filter</v-icon>
                        <v-btn class="ma-2" @click="active = false" color="red" dark><v-icon
                                dark>mdi-close-outline</v-icon></v-btn>
                    </h4>


                </div>


                <vs-sidebar-item index="2" class="my-2">
                    <multiselect v-model="busqueda.aseguradora"
                        deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                        select-label="Seleccionar valor" multiple track-by="clclave" label="clnombre"
                        placeholder="Seleccionar Aseguradora" :options="filteredOptions"
                        @input="obtenerFlotillasporCliente()" :allow-empty="true" @search-change="filterOptions"
                        :searchable="true" :internal-search="false">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.aseguradora != ''"
                                @mousedown.prevent.stop="busqueda.aseguradora = ''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="2" class="my-7">
                    <multiselect v-model="busqueda.flotilla" deselect-label="No se puede remover el valor seleccionado"
                        selected-label="Seleccionado" select-label="Seleccionar valor" track-by="flclave"
                        label="flnomcorto" placeholder="Seleccionar Flotilla"
                        :options="busqueda.aseguradora != '' ? flotillasTemp : flotillas" :allow-empty="false"
                        style="z-index: 500; position: absolute; width: 96%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.flotilla != ''"
                                @mousedown.prevent.stop="busqueda.flotilla = ''" :allow-empty="false"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="3" class="my-7">
                    <multiselect v-model="busqueda.estado" deselect-label="No se puede remover el valor seleccionado"
                        selected-label="Seleccionado" select-label="Seleccionar valor" track-by="esclave"
                        label="esnombre" placeholder="Seleccionar Estado" :options="estados" :allow-empty="false"
                        style="z-index: 500; position: absolute; width: 96%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.estado != ''"
                                @mousedown.prevent.stop="busqueda.estado = ''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="4" class="my-7">
                    <multiselect v-model="busqueda.gerencia" deselect-label="No se puede remover el valor seleccionado"
                        selected-label="Seleccionado" select-label="Seleccionar valor" track-by="geclave"
                        label="genombre" placeholder="Seleccionar Gerencia" :options="gerencias"
                        @input="obtenerSupervisoriaPorGerencia(), obtenerAbogados()" :allow-empty="false"
                        style="z-index: 500; position: absolute; width: 96%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.gerencia != ''"
                                @mousedown.prevent.stop="busqueda.gerencia = '', busqueda.supervisoria = '', busqueda.abogado = ''">
                            </div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="5" class="my-7">
                    <multiselect v-model="busqueda.supervisoria"
                        deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                        select-label="Seleccionar valor" track-by="suclave" label="sunombre"
                        placeholder="Seleccionar Supervisoría"
                        :options="busqueda.gerencia != '' ? supervisoriasTemp : supervisorias"
                        @input="obtenerAbogados()" :allow-empty="false"
                        style="z-index: 500; position: absolute; width: 96%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.supervisoria != ''"
                                @mousedown.prevent.stop="busqueda.supervisoria = '', busqueda.abogado = ''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="6" class="my-7">
                    <multiselect v-model="busqueda.abogado" deselect-label="No se puede remover el valor seleccionado"
                        selected-label="Seleccionado" select-label="Seleccionar valor" track-by="prclave"
                        label="prnombre" placeholder="Seleccionar Abogado"
                        :options="busqueda.supervisoria != '' || busqueda.gerencia != '' ? abogadosTemp : abogados"
                        :allow-empty="false" style="z-index: 500; position: absolute; width: 96%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="busqueda.abogado != ''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>

                <div class="footer-sidebar" slot="footer">
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                            <v-btn class="ma-2" @click="generarTablero()" color="blue" dark>Buscar <v-icon dark
                                    right>mdi-table-search</v-icon></v-btn>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                            <v-btn class="ma-2" @click="limpiarBusqueda()" color="red" dark>Limpiar <v-icon dark
                                    right>mdi-trash-can</v-icon></v-btn>
                        </vs-col>
                    </vs-row>
                </div>

            </vs-sidebar>
        </div>

        <div>
            <vs-popup class="holamundo" title="Ayuda" :active.sync="popupActivo">
                <p>
                    <vs-list>
                        <vs-list-header title="Iconos"></vs-list-header>
                        <vs-list-item subtitle="Liberación Física Vehículo">
                            <v-icon :color="'#8e44ad'" position="left">{{ 'mdi-car' }}</v-icon>
                        </vs-list-item>
                        <vs-list-item subtitle="Liberación Jurídica del vehículo">
                            <v-icon :color="'#f39c12'" position="left">{{ 'mdi-car-traction-control' }}</v-icon>
                        </vs-list-item>
                        <vs-list-item subtitle="Robo">
                            <v-icon position="left" :color="'#0A0A0A'">mdi-car-off</v-icon>
                        </vs-list-item>
                        <vs-list-item subtitle="Ingresar Seguimiento">
                            <v-icon :color="'#B3C9F1'" position="left">{{ 'mdi-file-document-edit' }}</v-icon>
                        </vs-list-item>
                        <vs-list-item subtitle="Ingreso a dar Seguimiento">
                            <v-icon x-large class="task-circle ml-1" :color="'#3cd4a0'">mdi-circle-medium</v-icon>
                        </vs-list-item>
                        <vs-list-item subtitle="Negociación Pendiente">
                            <v-icon :color="'#FC2B24'">mdi-briefcase</v-icon>
                        </vs-list-item>


                        <vs-list-header title="Indicador"></vs-list-header>
                        <vs-list-item subtitle="0-25% ">
                            <vs-button color="#9CA3AF" type="filled"></vs-button>
                        </vs-list-item>
                        <vs-list-item subtitle="26-50%">
                            <vs-button color="#10B981" type="filled"></vs-button>
                        </vs-list-item>
                        <vs-list-item subtitle="51-75%">
                            <vs-button color="#FDE68A" type="filled"></vs-button>
                        </vs-list-item>
                        <vs-list-item subtitle="76-100%">
                            <vs-button color="#F59E0B" type="filled"></vs-button>
                        </vs-list-item>
                        <vs-list-item subtitle="Mas de 100%">
                            <vs-button color="#EF4444" type="filled"></vs-button>
                        </vs-list-item>


                        <vs-list-header title="Borde"></vs-list-header>
                        <vs-list-item subtitle="Sin Solicitud de Conclusión">
                            <vs-button color="#EF4444" type="filled"></vs-button>
                        </vs-list-item>
                    </vs-list>
                </p>
            </vs-popup>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import SidebarService from '@/services/shared/sidebar.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import dash from '@/services/Dashboard/Dashboard.service.js';

export default {
    props: {
        validaFilter: false,
        validaHelp: false
    },
    data: () => ({
        active: false,
        uslogin: '',
        busqueda: {
            todo: false,
            proceso: '',
            aseguradora: '',
            flotilla: '',
            estado: '',
            gerencia: '',
            supervisoria: '',
            abogado: '',
            relevancia: ''
        },
        aseguradoras: [],
        flotillas: [],
        flotillasTemp: [],
        estados: [],
        gerencias: [],
        supervisorias: [],
        sepervisoriasTemp: [],
        abogados: [],
        relevancias: [],
        abogadosTemp: [],
        procesos: [],
        popupActivo: false,
        visuRelevancia: false,
        gerenciatemp: [],
        filteredOptions: [],
    }),
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    methods: {
        ...mapMutations('Operacion', ['asignarBusqueda', 'cambiarKey', 'verificandoBusqueda']),
        busquedaDefault() {
            return {
                proceso: { ...this.procesos[0] },
                aseguradora: '',
                flotilla: '',
                estado: '',
                gerencia: '',
                supervisoria: '',
                abogado: '',
                relevancia: ''
            }
        },
        obtenerFlotillasporCliente() {
            this.busqueda.flotilla = '';
            let temp = [];
            this.busqueda.aseguradora.forEach(aitem => {
                temp.push.apply(temp, this.flotillas.filter(item => item.clclave == aitem.clclave));
            })
            this.flotillasTemp = temp;
        },

        obtenerSupervisoriaPorGerencia() {
            this.busqueda.supervisoria = '';
            this.abogadosTemp = [];
            this.busqueda.abogado = '';

            if (this.busqueda.gerencia != '' && this.busqueda.gerencia != null) {
                this.busqueda.supervisoria = '';
                this.busqueda.abogado = '';
                this.supervisoriasTemp = this.supervisorias.filter(item => item.geclave == this.busqueda.gerencia.geclave);

            }


        },
        obtenerAbogados() {
            this.busqueda.abogado = '';
            if (this.busqueda.supervisoria != '' && this.busqueda.gerencia == '') {
                this.abogadosTemp = this.abogados.filter(item => item.suclave == this.busqueda.supervisoria.suclave)
            } else if (this.busqueda.supervisoria == '' && this.busqueda.gerencia == '') {
                this.abogadosTemp = this.abogados.filter(item => item.geclave == this.busqueda.gerencia.geclave)
            } else if (this.busqueda.supervisoria != '' && this.busqueda.gerencia != '') {
                this.abogadosTemp = this.abogados.filter(item => item.suclave == this.busqueda.supervisoria.suclave && item.geclave == this.busqueda.gerencia.geclave)
            }
        },
        async generarTablero() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.busqueda, "BusquedaFiltrox");
            this.verificandoBusqueda(false);
            this.asignarBusqueda(this.busqueda);
            this.cambiarKey({ tipo: 'T', key: Math.random() });
            this.active = false;
            this.RegistrarBusqueda();
        },
        RegistrarBusqueda() {
            MetodosGenerales.registrarPaginaVisitada(
                'Operacion', //modulo
                `Operacion-Dashboard-Busqueda`,   //name
                window.location.origin + window.location.pathname, //   url    
                this.domain.domainNameForApi,
                null,    //nrreporte,
                null//svindice
            );
        },
        async limpiarBusqueda() {
            this.abogadosTemp = [];
            this.busqueda = {
                todo: false,
                proceso: '',
                aseguradora: '',
                flotilla: '',
                estado: '',
                gerencia: '',
                supervisoria: '',
                abogado: '',
                relevancia: '',
                perfil: ''
            };
            await dash.DashboardPerfil(this).then(data => {
                if (data[0].geclave != '0' && data[0].geclave != 0) {
                    this.busqueda.gerencia = { geclave: data[0].geclave, genombre: data[0].genombre };
                }
                if (data[0].suclave != '0' && data[0].suclave != 0) {
                    this.busqueda.supervisoria = { suclave: data[0].suclave, sunombre: data[0].sunombre };
                    this.obtenerAbogados();
                }
                if (data[0].perfil == 'A') {
                    this.busqueda.abogado = { prclave: data[0].valor, prnombre: data[0].prnombre };
                    this.gerencias = this.gerencias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                }
                this.busqueda.perfil = data[0].perfil;
            });
        },
        temaSidebar() {
            if (this.THEME_STATE) {
                document.getElementsByClassName('vs-sidebar')[0].style.background = '#23232d';

            } else {
                document.getElementsByClassName('vs-sidebar')[0].style.background = '#FFFFFF';
            }
        },
        redireccionarIconografia() {
            this.busqueda = { ...this.busquedaDefault() };
        },

        async ActivarSide() {
            this.active = true;
            this.busqueda = {};
            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
                if (this.busqueda.perfil == 'A') {
                    if (this.busqueda.gerencia != '' && this.busqueda.gerencia != null)
                        this.gerencias = this.gerencias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                    this.supervisoriasTemp = this.supervisorias.filter(item => item.suclave == this.busqueda.supervisoria.suclave);
                }
                else if (this.busqueda.perfil == 'S') {
                    this.gerencias = this.gerencias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                    this.supervisoriasTemp = this.supervisorias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                    this.abogadosTemp = this.abogados.filter(item => item.suclave == this.busqueda.supervisoria.suclave);
                }
                else if (this.busqueda.perfil == 'G') {
                    this.gerencias = this.gerencias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                    this.supervisoriasTemp = this.supervisorias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                    if (this.busqueda.supervisoria != '' && this.busqueda.supervisoria != null)
                        this.abogadosTemp = this.abogados.filter(item => item.suclave == this.busqueda.supervisoria.suclave);
                    else
                        this.abogadosTemp = this.abogados.filter(item => item.geclave == this.busqueda.gerencia.geclave)
                }
                else {
                    if (this.busqueda.gerencia != '' && this.busqueda.gerencia != null)
                        this.supervisoriasTemp = this.supervisorias.filter(item => item.geclave == this.busqueda.gerencia.geclave);
                    if (this.busqueda.supervisoria != '' && this.busqueda.supervisoria != null)
                        this.abogadosTemp = this.abogados.filter(item => item.suclave == this.busqueda.supervisoria.suclave);

                }
                var url = window.location.origin + window.location.pathname;

                MetodosGenerales.registrarPaginaVisitada("operacion", "Dashboard", url, this.domain.domainNameForApi, 0, 0);
            }
            else
                this.$router.push({ name: `Dashboard` });


        },
        filterOptions(search) {
            if (!search) {
                this.filteredOptions = this.aseguradoras;
                return;
            }
            const term = this.normalize(search);
            this.filteredOptions = this.aseguradoras.filter(opt =>
                this.normalize(opt.clnombre).includes(term)
            );
        },
        normalize(str) {
            return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';
        },
    },
    async mounted() {
        setTimeout(() => {
            this.temaSidebar();
            this.active = false;
        }, 400);
        this.uslogin = this.getUser.get(this.permission.global).uslogin;
        SidebarService.obtenerAseguradoras(this);
        SidebarService.obtenerRelevancia(this);
        SidebarService.obtenerFlotillas(this);
        SidebarService.obtenerGerencias(this);
        SidebarService.obtenerSupervisorias(this);
        SidebarService.obtenerAbogados(this);
        SidebarService.obtenerEstados(this);
        SidebarService.obtenerProcesos(this);


    },
    beforeUpdate() {
        //this.temaSidebar();
    },
}
</script>

<style scope>
.header-sidebar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
}

.header-sidebar h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.header-sidebar h4>button {
    margin-left: 10px;
}

.footer-sidebar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.footer-sidebar>button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
}

.vs-sidebar {
    max-width: 350px !important;
}

.vs-sidebar.vs-sidebar-parent {
    position: fixed !important;
}

.vs-sidebar--background {
    background: none !important;
}

/*FLOTANTE  */
.btn-flotante {
    text-transform: uppercase;
    /* Texto en mayusculas */
    border-radius: 10px;
    /* Borde del boton */
    background-color: #747d8c;
    /* Color de fondo */
    padding: 2px 6px;
    /* Relleno del boton */
    position: fixed;
    top: 75px;
    right: 6px;
    transition: all 300ms ease 0ms;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    z-index: 99;
    opacity: 0.5;
}

.btn-flotante:hover {
    background-color: #2f3542;
    /* Color de fondo al pasar el cursor */
    box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3);
    transform: translateY(-7px);
}

@media only screen and (max-width: 600px) {
    .btn-flotante {
        padding: 2px 6px;
    }
}
</style>